export const updateReducerWithThunk = ({payload, type}) => (dispatch) => {
  dispatch({ type: type, payload });
};